<template>
	<div>
	</div>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	created() {
		console.log('window.location.href', window.location.href);
		const currentUrl = window.location.href;
		const reg = /\/map-member\/(\w+)/;
		const regResult = currentUrl.match(reg);
		console.log({ currentUrl, regResult });
		if (!currentUrl.includes('open') && regResult && regResult.length >= 2) {
			let base = window.location.href.split('/map-member/')[0];
			if (base.includes('app.')) base = base.replace('app.', 'shine.');
			if (base.includes('http://')) base = base.replace('http://', 'https://');
			let redir = `/ui/app/people/mappers?cardCode=${encodeURIComponent(regResult[1])}`;
			if (base.includes('https://shine')) redir = base + redir;
			// Use 'shine' host name, so that users do not have to log in twice; once
			// for shine, and once for app.
			window.location.href = redir;
		}
	}
}
</script>